import { type HSLColor, hsl, interpolateHsl, scaleLinear } from 'd3';
import { CHART_COLORS } from '../../../constants/chartColors';

export const COLOR_SCHEMES = [
  { h: 25, s: 0, l: 0 },
  { h: -25, s: 0, l: 0 },
  { h: 0, s: -0.1, l: 0.15 },
  { h: 0, s: 0, l: 0 },
  { h: 5, s: 0.2, l: 0.1 },
  { h: 0, s: 0.5, l: 0.15 },
];

export const getColorScales = ({
  numberOfColors,
  numberOfComparisons,
}: {
  numberOfColors: number;
  numberOfComparisons: number;
}) => {
  const colors = CHART_COLORS;
  const colorSchemes = COLOR_SCHEMES;

  const getColorScales = (baseColor: HSLColor, scheme: (typeof COLOR_SCHEMES)[0]) => {
    const from = hsl(baseColor.h - scheme.h, baseColor.s - scheme.s, baseColor.l - scheme.l).toString();
    const to = hsl(baseColor.h + scheme.h, baseColor.s + scheme.s, baseColor.l + scheme.l).toString();
    return scaleLinear<string>()
      .domain([0, numberOfColors - 1])
      .interpolate(interpolateHsl)
      .range([from, to]);
  };

  return Array.from({ length: numberOfComparisons }).map((_, i) => {
    const baseColor = hsl(colors[i % colors.length].default);
    const hoverColor = hsl(colors[i % colors.length].hover);
    const scheme = colorSchemes[i % colorSchemes.length];
    return {
      default: getColorScales(baseColor, scheme),
      hover: getColorScales(hoverColor, scheme),
    };
  });
};
